export const codeMigrateToTokensJS = `// CSS in JS
+import { token } from '@atlaskit/tokens';

export default () => <div css={{
-  color: B400,
+  color: token('color.background.selected.bold),
}} />`;

export const codeMigrateToTokensCSS = `// CSS variables, Sass, Less
.bg-surface {
  background: var(--ds-surface-raised, #eeeeee);
}`;

export const codeTokensCodemmod = `export const DangerMessage = styled.div\`
-  background-color: \${colors.R50};
+  background-color: \${token('color.background.danger')};

  :hover {
-    background-color: \${colors.R60};
+    background-color: \${token('color.background.danger.hovered')};
  }

  :active {
-    background-color: \${colors.R80};
+    background-color: \${token('color.background.danger.pressed')};
  }
\``;

export const codeCodemodCli = `# For CSS in JS
npx @hypermod/cli --packages="@atlaskit/tokens#theme-to-design-tokens" --experimental-loader --parser tsx <relative-path>
# For vanilla CSS, SASS, Less
npx @hypermod/cli --packages="@atlaskit/tokens#css-to-design-tokens" --extensions css,scss,less <relative-path>`;
